module.exports = __webpack_public_path__ + "static/media/rovan shot 06.2203c209.webp";